import React from 'react'
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import db from './db';
var functions = require("./functions.js");
// SearchTable Component
/*  Example
                    <SearchTable
                        securityObject={this.props.securityObject}
                        query={this.props.securityObject.httpServer + "api/get/facility?"}
                        columns={[
                                { key: 'facility_name', title:"client name", width :40 }
                                ,{ key: 'facility_address', title:"client address", width :40 }
                                ]}
                        onClick={this.selectClient.bind(this)}
                        tableHeight="40vh"
                    >
                    </SearchTable>
*/
export default class SearchTable extends React.Component {

    constructor(props) {
        let cols=props.columns;
        super(props);
        let refArray=[];
        if(!this.props.hideSearch){
            cols.forEach(col => {
                if(!col.noquery){
                    let inputRef = React.createRef();
                    refArray.push(inputRef);
                }
            });
        }
        this.state = {
            data:[]
            ,refArray:refArray
            ,tableDisplayColumns:this.props.columns               
        }
        //this.updateRefs();
    }    
    componentDidMount(prevProps) {
        setTimeout(() => { 
            let tableDisplayColumns=[];
            this.props.columns.forEach((col)=>{
                if(!col.doNotDisplayInTable){
                    tableDisplayColumns.push(col);
                }
            })            
            this.setState({
                tableDisplayColumns:tableDisplayColumns
            })
            if(this.props.openSearched){
                this.queryData();
            }
        }, 500);         
        this.defaultCursor();
    }
    componentDidUpdate(prevProps) {
    }
    /*
    updateRefs(){
        if(this.state.refArray.length==0 
            && this.props.columns.length>0){
            let refArray=[];
            this.props.columns.forEach(col => {
                if(!col.noquery){
                    let inputRef = React.createRef();
                    refArray.push(inputRef);
                }
            });
            this.setState({
                refArray:refArray
            })        
        }
    }
    */
    defaultCursor(){
        //  set focus on first input
        try{
            if(this.state.refArray && this.state.refArray.length>0){
                this.state.refArray[0].current.focus();
            }
        } catch(ex){}
    }
    // render
    render() {
        // create inputs for search
        let searchArr=[];
        this.inputArray=[];
        let i=0;
        let keyno=2000;
        if(!this.props.hideSearch){
            this.props.columns.forEach(col => {
                if(!col.noquery){
                    let inputRef = this.state.refArray[i];
                    i++;
                    keyno++;
                    let editClassName="search-table-input";
                    if(col.editClassName){
                        editClassName=col.editClassName;
                    }
                    let defaultValue='';
                    if (col.default_cookie_label){
                        defaultValue=functions.getCookieValue(col.default_cookie_label,'Production');
                    }
                    let input=React.createElement("input",{
                        onKeyUp:this.inputFilterKeyUp.bind(this)
                        ,name:col.key
                        ,ref:inputRef
                        ,key:keyno
                        ,id:"searchTableInput"+col.key
                        ,className:editClassName
                        ,defaultValue:defaultValue
                        ,default_cookie_label:col.default_cookie_label
                    })
                    this.inputArray.push(input);
                    keyno++;
                    searchArr.push(React.createElement( 
                        "span"
                        ,{
                            key:keyno
                            ,id:"labelTableInput"+col.key
                            //,className:editClassName
                        }
                        ," "+col.title+": "));
                    searchArr.push(input);
                }
            })
            

            // add the search button
            searchArr.push(
                React.createElement("button"
                    ,{ id:`search-button`
                        ,onClick:this.queryData.bind(this)
                        ,key:"searchButton"
                    }
                    ,"search"));
        }
        // render the screen
        return(true) ? (
            <span className="search-table">
                <h3  id='searchTableSearchHeader' >{searchArr} </h3>
                <TableScrollbar height={this.props.tableHeight} width={this.props.tableWidth}>
                    <ErrorBoundary>
                        <Table 
                            dataSource={this.state.data}
                            onRowClick={this.selectRow.bind(this)} 
                            columns={this.state.tableDisplayColumns} 
                        />
                    </ErrorBoundary>
                </TableScrollbar>
            </span>
        ) :"";
    }
    selectRow( rowData, rowIndex ){
        if(this.props.onClick){
            this.props.onClick(rowData);
        }
    }
    queryData(afterDataReceived){
        let qry=this.props.query;
        this.state.refArray.forEach(ref => {
            let val=ref.current.value;
            console.log(val);
            if(val.length>0){
               qry+=ref.current.name+"="+val+"&";
            }
            this.props.columns.forEach( (col)=>{
                if(col.default_cookie_label && col.key===ref.current.name){
                    functions.saveCookieValue( col.default_cookie_label, val );
                }
            } )
        })
        db.getSearchPopupData( 
            qry
            ,this.props.securityObject
            ,(list) => { 
                this.setState({
                    data : list
                })
                if(this.props.afterDataReceived){
                    this.props.afterDataReceived(list);
                }                
                if(this.props.afterQuery){
                    this.props.afterQuery(this.state.refArray,list);
                }
            }
        )
    }
    inputFilterKeyUp(event) {
        if (event.keyCode === 13) {
          this.queryData();
        }
    }
}

